import { formatAuthor, formatAuthorType, formatImage } from "./formatFields";

const stripTags = (text) => text?.replace(/(<([^>]+)>)/gi, "");
const getURL = (path) => {
  const baseURL = process.env.REACT_APP_URL || window?.location.origin || "";

  return baseURL + (path || window?.location.pathname || "")
};

const MetadataFactory = function (props) {
  let metadata = {
    "@context": {
      "@vocab": "https://schema.org/",
      "dc": "http://purl.org/dc/elements/1.1/",
    },
    ...props
  };

  return {
    addProperty: function (name, value) {
      if (value) metadata[name] = value;
      return this;
    },
    addId: function (id) {
      metadata["@id"] = getURL(id);
      return this;
    },
    addUrl: function (path) {
      metadata.url = getURL(path);
      return this;
    },
    addName: function (name) {
      if (name) {
        metadata.name = name;
        metadata["dc:title"] = metadata.name;
      }
      return this;
    },
    addDescription: function (description) {
      if (description) metadata.description = stripTags(description);
      return this;
    },
    addTeaches: function (learningOutcomes) {
      if (learningOutcomes && learningOutcomes.length > 0)
        metadata.teaches = learningOutcomes.map(learningOutcome => learningOutcome.item);
      return this;
    },
    addCreator: function (authors) {
      if (authors && authors.length > 0) {
        metadata.author = authors
          .filter(author => formatAuthorType(author) !== null)
          .map(author => {
            const result = {
              "@type": formatAuthorType(author),
              "name": formatAuthor(author, false),
            };

            if (author.type === "person" && !!author.person?.institution) {
              result.affiliation = {
                "@type": "Organization",
                "name": author.person.institution.name
              };
            }
            return result;
          });
      }
      return this;
    },
    addHasPart: function (parts, type) {
      if (parts && parts.length > 0) {
        metadata.hasPart = parts.map(part => ({
          "@type": "LearningResource",
          "learningResourceType": type,
          "name": part.name
        }));
      }
      return this;
    },
    addSubject: function (subjects) {
      if (subjects && subjects.length > 0) {
        metadata.about = subjects.map(subject => subject.name);
        metadata["dc:subject"] = metadata.about;
      }
      return this;
    },
    addEducationalLevel: function (educationalLevels) {
      if (educationalLevels && educationalLevels.length > 0)
        metadata.educationalLevel = educationalLevels.map(educationalLevel => educationalLevel.name);
      return this;
    },
    addKeywords: function (keywords) {
      if (keywords && keywords.length > 0)
        metadata.keywords = keywords.map(keyword => keyword.name);

      return this;
    },
    addLicense: function (license) {
      if (license)
        metadata.license = license.referenceURL;

      return this;
    },
    addDatePublished: function (date) {
      const parsedDate = Date.parse(date);
      if (!isNaN(parsedDate)) {
        metadata.datePublished = (new Date(parsedDate)).toISOString().substring(0, 10);
      }

      return this;
    },
    addPublisher: function (publisher) {
      if (publisher) {
        metadata.publisher = {
          "@type": "Organization",
          "name": publisher
        };
      }

      return this;
    },
    addImage: function (image) {
      if (image) {
        metadata.thumbnailUrl = formatImage(image, "thumbnail");
        metadata.image = formatImage(image, "large");
      }

      return this;
    },
    stringify: function () {
      return JSON.stringify(metadata);
    },
    raw: metadata,
  };
};

export { MetadataFactory, stripTags }
export default MetadataFactory;
